import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { lastValueFrom, Subject, takeUntil } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { FirmaStateService } from 'src/app/core/states/firma/firma-state.service';
import { PlantillasService } from 'src/app/core/services/plantilla.service';
import { AuthService } from 'src/app/core/services/AuthService';
import { k } from 'src/environments/properties';
import Swal, { SweetAlertIcon } from 'sweetalert2';

@Component({
    selector: 'batch-configuration-plantilla-component',
    templateUrl: './batch-configuration-plantilla.component.html',
    styleUrls: ['./batch-configuration-plantilla.css'],
})
export class BatchConfigurationPlantillaComponent implements OnInit {
    private destroy$ = new Subject<void>(); // Usado para desuscribir los Observables al destruir el componente
    plantillaForm: FormGroup;
    @Output() dataAddPlantilla: EventEmitter<any> = new EventEmitter<any>();
    returnDataAddPlantilla: any;
    idPlantilla: number;
    // Toast
    toast = Swal;
    accesUser: boolean = false;
    userToken: any;

    @Input() resolverStepInicial = false;
    @Input() resolucionInicialActiva = false;
    @Output() stepRedirect = new EventEmitter<number>();
    private redireccionInicialRealizada = false;




    constructor(
        private firmaStateService: FirmaStateService,
        private authService: AuthService,
        private plantillaService: PlantillasService,
        private router: Router,
        private route: ActivatedRoute,
        private fb: FormBuilder,
    ) {

    }


    ngOnInit() {
        this.toastAlert();
        this.accesUser = this.authService.hasRoleAuth('ADMINISTRADOR');
        
        this.route.paramMap
            .pipe(takeUntil(this.destroy$)) // Desuscribe automáticamente al destruir el componente
            .subscribe(async params => {
                // 'id' es el nombre del parámetro definido en tu configuración de rutas
                const id = params.get('id');
                if (Number(id)) {
                    this.idPlantilla = Number(id);
                    await this.preCargarPlantilla();
                }
            });

        this.plantillaForm = this.fb.group({
            nombre: ['', [Validators.required, Validators.minLength(3)]],
            publica: [false]
        });

    }

    async addPlantilla(): Promise<boolean> {
        let data = this.plantillaForm.value;
        let msg = '';

        if (this.plantillaForm.valid) {
            if (this.idPlantilla) { //PUT

                this.returnDataAddPlantilla = await lastValueFrom(this.plantillaService.updPlantilla(data, this.idPlantilla));
                msg = 'Configuración actualizada'

            } else { //POST
                this.returnDataAddPlantilla = await lastValueFrom(this.plantillaService.addPlantilla(data));
                msg = 'Configuración guardada'
            }

            if (this.returnDataAddPlantilla) {
                this.alert('success', msg);
                this.dataAddPlantilla.emit(this.returnDataAddPlantilla);
                return true;
            } else {
                return false;
            }
        } else {
            this.plantillaForm.markAllAsTouched(); // Marcar para mostrar errores al usuario
            return false; // Indica que el guardado falló debido a la validación
        }

    }

    // async accesRol() {
    //     this.userToken = localStorage.getItem(k.token);

    //     if (this.userToken) {
    //         const dataUser = await this.authService.dataUser(this.userToken);

    //         const hasAccess = (dataUser.roles as string[]).some(role => this.authService.hasRoleAuth(role));
    //         console.log('hasAccess: ', hasAccess);
    //     }
    // }

    async preCargarPlantilla() {
        const response = await lastValueFrom(
            this.plantillaService.showDocumenPlantilla(this.idPlantilla)
        );

        this.returnDataAddPlantilla = response.body;

        this.dataAddPlantilla.emit(this.returnDataAddPlantilla);

        this.plantillaForm.patchValue({
            nombre: response.body.nombre,
            publica: response.body.publica
        });

        if (
            this.resolucionInicialActiva &&
            response.body.url
        ) {
            this.stepRedirect.emit(1);
        }
    }

    guardar() {

        alert('Formulario enviado correctamente');
    }

    toastAlert() {
        this.toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.onmouseenter = Swal.stopTimer;
                toast.onmouseleave = Swal.resumeTimer;
            }
        });
    }

    alert(icontext: SweetAlertIcon, title: string) {
        this.toast.fire({
            icon: icontext,
            title: title
        });
    }

}
